<template>
    <v-dialog
      v-model="localDialog"
      max-width="500"
      dark black
    >
    	<s-card class="grey darken-3">
        <span class=" d-block headline white--text mt-4 mb-4" :class="[$vuetify.breakpoint.mdAndUp ? 'mb-0 px-3 ' : 'px-5 mb-2']">
          Netbeheeder: {{ operator.name }}
        </span>
    		<v-simple-table dense class="pa-2">
    		<template v-slot:default>
    			<tbody>
    			<tr>
    			<td class="pa-3 font-weight-bold" style="width: 50% !important;">Naam</td>
    			<td class="pa-3" style="width: 50% !important;">{{ operator.name }}</td>
    			</tr>
    			<tr v-if="operator.ean">
    				<td class="pa-3 font-weight-bold">EAN</td>
    				<td class="pa-3">{{ operator.ean }}</td>
    			</tr>
    			<tr>
    			<td class="pa-3 font-weight-bold">Telefoon</td>
    			<td class="pa-3"><a class="white--text" :href="'tel:' + operator.phone">{{ operator.phone }}</a></td>
    			</tr>
    			<tr>
    			<td class="pa-3 font-weight-bold">E-mail</td>
    				<td class="pa-3"><a class="white--text" :href="'mailto:' + operator.email">{{ operator.email }}</a></td>
    			</tr>
    			<tr>
    			<td class="pa-3 font-weight-bold">Website</td>
    				<td class="pa-3"><a class="white--text" v-bind:href="operator.website ">{{ operator.website }}</a></td>
    			</tr>
    			<tr v-if="operator.maintenance">
    			<td class="pa-3 font-weight-bold">In onderhoud</td>
    			<td class="pa-3">{{ operator.maintenance }}</td>
    			</tr>
    			</tbody>
    		</template>
    		</v-simple-table>
    		<v-card-actions class="pa-3 grey darken-2">
    		<v-spacer></v-spacer>
    		<v-btn
    			color="primary" to="" class="text-none text-none"
    			v-html="'Sluiten'" @click="localDialog=false;"
    		></v-btn>

    		</v-card-actions>
    	</s-card>
    </v-dialog>
</template>

<script>
export default {
  props: ['operator', 'dialog'],
  name: '',
  data() {
    return {};
  },
  computed: 
  {
    localDialog:
    {
        get: function(){ return this.dialog; },
        set: function(value){ this.$emit('update:dialog', value); }
    }
  }
};
</script>
